import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./registrationfrom.css";
// import DropDown from "./Dropdown";
// import FormInputs from "./FormInputs";
import DropDown from "../../Components/Shared/Dropdown/Dropdown";
import FormInputs from "../../Components/Shared/FormInputs/FormInputs";
import AWS from "aws-sdk";
import Swal from "sweetalert2";
import UploadImgIcon from "../../Assets/Images/EployeeRegistration/icon-image.png";
import EditIcon from "../../Assets/Images/EployeeRegistration/edit_icon.png";
import { fetchGenderData } from "../../Redux/EmployeeRegistration/genderSlice";
import { fetchCategorynData } from "../../Redux/EmployeeRegistration/categorySlice";
import { fetchSubCategorynData } from "../../Redux/StudentRegistration/subcategorySlice";
import { fetchCourseData } from "../../Redux/StudentRegistration/courseSlice";
import { fetchCoachingData } from "../../Redux/StudentRegistration/coachingSlice";
import { fetchStateData } from "../../Redux/StudentRegistration/stateSlice";
import { fetchClassTypeData } from "../../Redux/StudentRegistration/classTypeSlice";
import { API_BASE_URL } from "../../Config/Config";
import AvatarEditor from "react-avatar-editor";
import CropperModal from "./Cropper";
// import SearchDropdown from "./SearchDropdown";
import SearchDropdown from "../OTC/dropdownInput";

function PersonalInfo({ setPersonalInfo }) {
  const { statedata, loading, error } = useSelector((state) => state.domstate);
  const dispatch = useDispatch();
  const [croppedImageBlob, setCroppedImageBlob] = useState(null);
  const [crop, setCrop] = useState(null);
  const [image, setImage] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const { subcategorydata } = useSelector((state) => state.subcategoies);
  const { genderdata } = useSelector((state) => state.gender);
  const { categorydata } = useSelector((state) => state.categories);
  const { coursesdata } = useSelector((state) => state.course);
  const { coachingData } = useSelector((state) => state.coaching);
  // const { statedata } = useSelector((state) => state.domstate);
  const { classtypedata } = useSelector((state) => state.classType);
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [isOpen, setIsOpen] = useState(true);
  // const [image, setImage] = useState(null);
  const [fileName, setFileName] = useState("No selected file");
  const cropperRef = useRef(null);
  const [src, setSrc] = useState(null);

  const [rollNumberMessage, setRollNumberMessage] = useState("");
  const [values, setValues] = useState({
    enquiry_id: null,
    roll_number: "",
    class_type_id: null,
    student_first_name: "",
    student_middle_name: "",
    student_last_name: "",
    date_of_birth: "",
    gender_id: 0,
    aadhaar_no: "",
    category_id: null,
    sub_category_id: null,
    domicile_city_id: 0,
    student_mob_no: "",
    email_id: "",
    emrgency_contact_mob_no: "",
    course_id: null,
    last_coaching_id: null,
    delete_flag: 0,
    photograph: "",
  });
  const [selectedState, setSelectedState] = useState(null);

  // setPersonalInfo(values);
  // Add this useEffect to update parent component
  useEffect(() => {
    const currentValues = { ...values };
    if (croppedImageBlob) {
      currentValues.IMG = croppedImageBlob;
    }
    setPersonalInfo(currentValues);
  }, [values, croppedImageBlob]);

  useEffect(() => {
    dispatch(fetchGenderData());
    dispatch(fetchCategorynData());
    dispatch(fetchSubCategorynData());
    dispatch(fetchCourseData());
    dispatch(fetchCoachingData());
    dispatch(fetchStateData());
    dispatch(fetchClassTypeData());
  }, [dispatch]);

  // const onChange = (event) => {
  //   const { name, value } = event.target;
  //   // Update your form state with the new value
  //   setValues({ ...values, [name]: value });
  //   // Make API call to check if the roll number exists
  //   if (name === "roll_number") {
  //     fetch(
  //       `${API_BASE_URL}/coaching-collaborator-api/api/v1/check_roll_no/?roll_no=${value}`
  //     )
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data.status === 200) {
  //           // Set the message received from the API
  //           setRollNumberMessage(data.message);
  //           // Display the message in a swal
  //           Swal.fire({
  //             text: data.message,
  //             icon: "info",
  //             confirmButtonColor: "#318682",
  //           });
  //         }
  //       })
  //       .catch((error) => console.error("Error checking roll number:", error));
  //   }
  // };

  const onChange = (event) => {
    const { name, value } = event.target;
    setValues({ ...values, [name]: value });

    // Check roll number on blur (when user leaves the field)
    if (name === "roll_number") {
      const inputElement = event.target;

      // Add blur event listener to show popup when user leaves the field
      const handleBlur = () => {
        if (value.trim()) {
          // Only check if roll number has value
          fetch(
            `${API_BASE_URL}/coaching-collaborator-api/api/v1/check_roll_no/?roll_no=${value.trim()}`
          )
            .then((response) => response.json())
            .then((data) => {
              if (data.status === 200) {
                setRollNumberMessage(data.message);
                Swal.fire({
                  text: data.message,
                  icon: "warning", // Changed to warning for better UX
                  confirmButtonColor: "#318682",
                  // timer: 3000,
                  showConfirmButton: true,
                });
              }
            })
            .catch((error) => {
              console.error("Error checking roll number:", error);
              Swal.fire({
                text: "Error checking roll number. Please try again.",
                icon: "error",
                confirmButtonColor: "#318682",
              });
            })
            .finally(() => {
              // Clean up the blur listener after execution
              inputElement.removeEventListener("blur", handleBlur);
            });
        }
      };

      // Add the blur listener
      inputElement.addEventListener("blur", handleBlur);
    }
  };

  // Add this as a separate handler
  const handleRollNumberBlur = (e) => {
    const rollNumber = e.target.value.trim();
    if (rollNumber) {
      fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/check_roll_no/?roll_no=${rollNumber}`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            Swal.fire({
              text: data.message,
              icon: "warning",
              confirmButtonColor: "#318682",
              // timer: 3000,
            });
          }
        })
        .catch((error) => console.error("Error checking roll number:", error));
    }
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const s3 = new AWS.S3({
    accessKeyId: "AKIAUFB5JPBW5EP45JD7",
    secretAccessKey: "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",
    region: "ap-south-1",
  });
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      const reader = new FileReader();
      reader.onload = () => {
        setSrc(reader.result); // Set src for cropper
        setImage(reader.result); // Set image for preview
        setShowCropper(true);
      };
      reader.readAsDataURL(file);
    }
  };
  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setFileName(file.name);
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       setImage(reader.result);
  //     };
  //     reader.readAsDataURL(file);

  //     // Upload image to S3
  //     const params = {
  //       Bucket: "dseinfotech",
  //       Key: `dev/coaching_collab/student_registration/${file.name}`,
  //       Body: file,
  //     };
  //     s3.upload(params, (err, data) => {
  //       if (err) {
  //         console.error("Error uploading file:", err);
  //       } else {
  //         console.log("File uploaded successfully:", data.Location);
  //         setUploadedImageUrl(data.Location);
  //         setValues({ ...values, photograph: data.Location }); // Save S3 image URL in values
  //       }
  //     });
  //   }
  // };

  // const handleDeleteImage = () => {
  //   setImage(null);
  //   setFileName("");
  //   setUploadedImageUrl("");
  //   // Remove the image URL from values when deleting the image
  //   setValues({ ...values, photograph: "" });
  // };

  // const [showCropper, setShowCropper] = useState(false);
  // const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  // Add these new functions before your return statement
  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };
  // Add this handler function before your return statement
  const handleCroppedImage = (croppedFile) => {
    // Update image states
    setCroppedImageBlob(croppedFile);
    setImage(URL.createObjectURL(croppedFile));

    // Update form values
    setValues((prev) => ({
      ...prev,
      photograph: croppedFile,
    }));

    // Update parent component
    setPersonalInfo((prev) => ({
      ...prev,
      IMG: croppedFile,
    }));

    // Reset cropper state
    setShowCropper(false);
    setSrc(null);
  };

  // Update handleDeleteImage function
  // Update handleDeleteImage function
  const handleDeleteImage = () => {
    // Clear image states
    setImage(null);
    setSrc(null);
    setFileName("No selected file");
    setCroppedImageBlob(null);

    // Clear form values
    setValues((prev) => ({
      ...prev,
      photograph: null,
    }));

    // Clear parent component state
    setPersonalInfo((prev) => ({
      ...prev,
      IMG: null,
    }));

    // Close cropper if open
    setShowCropper(false);
  };

  // const handleStateSelect = (selectedOption) => {
  //   setSelectedState(selectedOption);
  //   setPersonalInfo((prev) => ({
  //     ...prev,
  //     domicile_city_id: selectedOption.state_id,
  //   }));
  // };

  const handleStateSelect = (selectedOption) => {
    setValues((prevValues) => ({
      ...prevValues,
      domicile_city_id: selectedOption ? selectedOption.state_id : null, // Handle null case
    }));
  };

  const handleCropComplete = async () => {
    if (!cropperRef.current) return;

    try {
      const dataUrl = cropperRef.current.getImage().toDataURL();
      const result = await fetch(dataUrl);
      const blob = await result.blob();

      const timestamp = new Date().getTime();
      const filename = `profile_${timestamp}.jpg`;

      const file = new File([blob], filename, {
        type: "image/jpeg",
        lastModified: Date.now(),
      });

      handleCroppedImage(file);
    } catch (err) {
      console.error("Image processing error:", err);
    }
  };
  // const handleCropComplete = () => {
  //   const cropper = cropperRef.current;
  //   if (cropper) {
  //     const canvas = cropper.getCanvas();
  //     if (canvas) {
  //       // Get the cropped image as data URL
  //       const croppedImageUrl = canvas.toDataURL("image/jpeg");

  //       // Update the image state with cropped image
  //       setImage(croppedImageUrl);

  //       // Convert data URL to blob for form submission
  //       fetch(croppedImageUrl)
  //         .then((res) => res.blob())
  //         .then((blob) => {
  //           const file = new File([blob], fileName, { type: "image/jpeg" });
  //           setCroppedImageBlob(file);

  //           // Update form values
  //           setValues((prev) => ({
  //             ...prev,
  //             photograph: file,
  //           }));

  //           // Update parent component
  //           setPersonalInfo((prev) => ({
  //             ...prev,
  //             IMG: file,
  //           }));
  //         });

  //       // Close the cropper
  //       setShowCropper(false);
  //     }
  //   }
  // };
  const createImage = (url) =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener("load", () => resolve(image));
      image.addEventListener("error", (error) => reject(error));
      image.src = url;
    });

  const getCroppedImg = async (imageSrc, pixelCrop) => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(URL.createObjectURL(blob));
      }, "image/jpeg");
    });
  };

  // Replace your existing handleImageChange function with this
  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setFileName(file.name);
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       setImage(reader.result);
  //       setShowCropper(true);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  // // Add new function to handle crop confirmation
  // const handleCropComplete = async () => {
  //   try {
  //     const croppedImage = await getCroppedImg(image, croppedAreaPixels);

  //     // Convert blob URL to blob
  //     const response = await fetch(croppedImage);
  //     const blob = await response.blob();

  //     // Upload to S3
  //     const params = {
  //       Bucket: "dseinfotech",
  //       Key: `dev/coaching_collab/student_registration/${fileName}`,
  //       Body: blob,
  //     };

  //     s3.upload(params, (err, data) => {
  //       if (err) {
  //         console.error("Error uploading file:", err);
  //       } else {
  //         setUploadedImageUrl(data.Location);
  //         setValues({ ...values, photograph: data.Location });
  //       }
  //     });

  //     setImage(croppedImage);
  //     setShowCropper(false);
  //   } catch (e) {
  //     console.error("Error cropping image:", e);
  //   }
  // };

  // Replace the image upload section in your JSX with this

  useEffect(() => {
    const currentValues = { ...values };
    if (croppedImageBlob) {
      currentValues.IMG = croppedImageBlob;
      // Add console log to verify image data
      console.log("PersonalInfo - Sending image:", {
        imageSize: croppedImageBlob.size,
        imageType: croppedImageBlob.type,
        imageName: croppedImageBlob.name,
      });
    }
    setPersonalInfo(currentValues);
  }, [values, croppedImageBlob]);

  return (
    <div className="personal-info">
      <div className="personal-header">
        <div className="header">
          <h2>PERSONAL INFORMATION</h2>
          <img src={EditIcon} alt="icon" />
        </div>
        <div className="accordion-btn" onClick={toggleAccordion}>
          {isOpen ? (
            <div className="minus"></div>
          ) : (
            <div className="plus">+</div>
          )}
        </div>
      </div>
      {isOpen &&
        classtypedata &&
        statedata &&
        coachingData &&
        coursesdata &&
        categorydata &&
        genderdata &&
        subcategorydata && (
          <div className="accordion-content">
            <div className="grid-container">
              <div className="item1">
                <div>
                  <FormInputs
                    label="Enquiry Number"
                    type="text"
                    name="enquiry_id"
                    value={values.enquiry_id}
                    onChange={onChange}
                    maxlength="50"
                    pattern="[0-9]{1,50}"
                    disabled
                    bg="#d6d6d6"
                  />
                </div>
              </div>
              <div className="item2" style={{ position: "relative" }}>
                {/* <FormInputs
                  label="Student Roll Number"
                  type="text"
                  name="roll_number"
                  value={values.roll_number}
                  onChange={onChange}
                  // maxlength="50"
                  maxLength={10}
                  pattern="[A-Za-z,0-9]{1,50}"
                  required
                /> */}
                <FormInputs
                  label="Student Roll Number"
                  type="text"
                  name="roll_number"
                  value={values.roll_number}
                  onChange={onChange}
                  onBlur={handleRollNumberBlur} // Add this
                  maxLength={10}
                  pattern="[A-Za-z,0-9]{1,50}"
                  required
                />
              </div>
              <div className="item3">
                <div className="selecte-dropdown-items">
                  <DropDown
                    label="Class Type"
                    setSelected={(selectedOption) =>
                      setValues({ ...values, class_type_id: selectedOption })
                    }
                    options={[
                      { label: "Online", id: 1 },
                      { label: "Classroom", id: 2 },
                    ]}
                    isRequired={true}
                  />
                </div>
              </div>
              <div className="item4">
                <FormInputs
                  label="First Name"
                  type="text"
                  name="student_first_name"
                  value={values.student_first_name}
                  onChange={onChange}
                  maxlength="50"
                  pattern="[A-Za-z]{1,50}"
                  required
                />
              </div>
              <div className="item5">
                <FormInputs
                  label="Middle Name"
                  type="text"
                  name="student_middle_name"
                  value={values.student_middle_name}
                  onChange={onChange}
                  maxlength="50"
                  pattern="[A-Za-z]{1,50}"
                />
              </div>
              <div className="item6">
                <FormInputs
                  label="Last Name"
                  type="text"
                  name="student_last_name"
                  value={values.student_last_name}
                  onChange={onChange}
                  maxlength="50"
                  pattern="[A-Za-z]{1,50}"
                />
              </div>
              <div className="item7">
                <FormInputs
                  label="Date of Birth"
                  type="date"
                  name="date_of_birth"
                  value={values.date_of_birth}
                  onChange={onChange}
                  required
                />
              </div>
              <div className="item8">
                <div className="selecte-dropdown-items">
                  <DropDown
                    label="Gender"
                    setSelected={(selectedOption) =>
                      setValues({ ...values, gender_id: selectedOption })
                    }
                    options={genderdata.map((gender) => ({
                      label: gender.gender_name,
                      id: gender.gender_id,
                    }))}
                    isRequired={true}
                  />
                </div>
              </div>
              <div className="item9">
                <FormInputs
                  label="Aadhar Number"
                  type="text"
                  name="aadhaar_no"
                  value={values.aadhaar_no}
                  onChange={onChange}
                  pattern="[0-9]{12}"
                  maxLength={12}
                />
              </div>
              <div className="item10">
                <div className="selecte-dropdown-items">
                  <DropDown
                    label="Category"
                    setSelected={(selectedOption) =>
                      setValues({ ...values, category_id: selectedOption })
                    }
                    options={categorydata.map((cat) => ({
                      label: cat.category_desc,
                      id: cat.category_id,
                    }))}
                    isRequired={true}
                  />
                </div>
              </div>
              <div className="item11">
                <div className="selecte-dropdown-items">
                  {/* <DropDown
                    label="Sub Category"
                    setSelected={(selectedOption) =>
                      setValues({ ...values, sub_category_id: selectedOption })
                    }
                    options={subcategorydata.map((subcat) => ({
                      label: subcat.sub_category_desc,
                      id: subcat.sub_category_id,
                    }))}
                    isRequired={false}
                  /> */}
                  <DropDown
                    label="Sub Category"
                    setSelected={(selectedOption) =>
                      setValues({ ...values, sub_category_id: selectedOption })
                    }
                    options={[
                      ...subcategorydata.map((subcat) => ({
                        label: subcat.sub_category_desc,
                        id: subcat.sub_category_id,
                      })),
                    ]}
                    isRequired={true}
                  />
                </div>
              </div>
              <div
                className="item12"
                style={{
                  gridRowStart: "4",
                  gridRowEnd: "8",
                  gridColumnStart: "3",
                  gridColumnEnd: "3",
                }}
              >
                <div style={{ width: "100%" }}>
                  <label>Photograph</label>
                  <div className="input-image">
                    <div className="input-image-field">
                      <input
                        type="file"
                        accept="image/*"
                        name="photograph"
                        className="input-field"
                        hidden
                        onChange={handleImageChange}
                      />
                      {!showCropper ? (
                        <>
                          {image ? (
                            <div
                              style={{
                                width: "200px",
                                height: "200px",
                                overflow: "hidden",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                              }}
                            >
                              <img
                                className="uploaded-img"
                                src={image}
                                alt={fileName}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          ) : (
                            <div className="icon-img-container">
                              <img
                                src={UploadImgIcon}
                                alt="upload icon"
                                className="icon-img"
                              />
                            </div>
                          )}
                        </>
                      ) : (
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            height: "300px",
                          }}
                        >
                          {/* <CropperModal
                            src={src}
                            modalOpen={showCropper}
                            setModalOpen={setShowCropper}
                            onSave={handleCroppedImage}
                          /> */}
                          <CropperModal src={src} cropperRef={cropperRef} />
                          {/* <Cropper
                            ref={cropperRef}
                            src={image}
                            className="cropper"
                            stencilProps={{
                              aspectRatio: 1,
                              grid: true,
                            }}
                            defaultSize={{
                              width: 200,
                              height: 200,
                            }}
                          /> */}
                        </div>
                      )}
                    </div>
                    {/* <div className="image-btns-container">
                      {image ? (
                        <div
                          className="replace-image-btn"
                          onClick={() =>
                            document.querySelector(".input-field").click()
                          }
                        >
                          Replace
                        </div>
                      ) : (
                        <div
                          className="replace-image-btn"
                          onClick={() =>
                            document.querySelector(".input-field").click()
                          }
                        >
                          Upload
                        </div>
                        
                      )}
                      {image && (
                        <div
                          className="del-image-btn"
                          onClick={handleDeleteImage}
                        >
                          Delete
                        </div>
                      )}
                    </div> */}
                    <div className="image-btns-container">
                      {showCropper ? (
                        <>
                          <div
                            className="replace-image-btn"
                            style={{ marginBottom: "10px" }}
                            onClick={handleCropComplete}
                          >
                            Save Changes
                          </div>
                          <div
                            className="replace-image-btn"
                            onClick={() =>
                              document.querySelector(".input-field").click()
                            }
                          >
                            Replace
                          </div>
                          <div
                            className="del-image-btn"
                            onClick={handleDeleteImage}
                          >
                            Delete
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className="replace-image-btn"
                            onClick={() =>
                              document.querySelector(".input-field").click()
                            }
                          >
                            {image ? "Replace" : "Upload"}
                          </div>
                          {image && (
                            <>
                              <div
                                className="del-image-btn"
                                onClick={handleDeleteImage}
                              >
                                Delete
                              </div>
                              {/* <div
                                className="replace-image-btn"
                                onClick={handleCropComplete}
                              >
                                Save Changes
                              </div> */}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="item13">
                <div className="selecte-dropdown-items">
                  {/* <DropDown
                    label="Domicile State"
                    setSelected={(selectedOption) =>
                      setValues({ ...values, domicile_city_id: selectedOption })
                    }
                    options={statedata.map((state) => ({
                      label: state.state_name,
                      id: state.state_id,
                    }))}
                    isRequired={true}
                    Height="300px"
                    OverFlow="auto"
                  /> */}
                  <div>
                    {loading ? (
                      <p>Loading states...</p>
                    ) : error ? (
                      <p>Error loading states: {error}</p>
                    ) : (
                      <SearchDropdown
                        initialOptions={statedata || []}
                        onSelect={handleStateSelect}
                        placeholder="Type to search..."
                        label="Domicile State"
                        labelKey={(option) => option.state_name} // Use state_name for display and filtering
                      />
                    )}
                    {/* {selectedState && (
                      <p>
                        Selected State:{" "}
                        <strong>{selectedState.state_name}</strong>
                      </p>
                    )} */}
                  </div>
                </div>
              </div>
              <div className="item14">
                <FormInputs
                  label="Mobile Number"
                  type="text"
                  name="student_mob_no"
                  value={values.student_mob_no}
                  onChange={onChange}
                  pattern="[0-9]{10,11}"
                  maxLength={10}
                  required
                />
              </div>
              <div className="item15">
                <FormInputs
                  label="Student Email ID"
                  type="email"
                  name="email_id"
                  value={values.email_id}
                  onChange={onChange}
                  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{{2,}}"
                />
              </div>
              <div className="item16">
                <FormInputs
                  label="Emergency Contact Number"
                  type="text"
                  name="emrgency_contact_mob_no"
                  value={values.emrgency_contact_mob_no}
                  onChange={onChange}
                  pattern="[0-9]{10,11}"
                  maxLength={10}
                  required
                />
              </div>
              <div className="item17">
                <div className="selecte-dropdown-items">
                  <DropDown
                    label="Course"
                    setSelected={(selectedOption) =>
                      setValues({ ...values, course_id: selectedOption })
                    }
                    options={coursesdata.map((course) => ({
                      label: course.course_description,
                      id: course.course_id,
                    }))}
                    isRequired={true}
                  />
                </div>
              </div>
              <div className="item12">
                <div className="selecte-dropdown-items">
                  <DropDown
                    label="Previous coaching"
                    setSelected={(selectedOption) =>
                      setValues({ ...values, last_coaching_id: selectedOption })
                    }
                    options={coachingData.map((coach) => ({
                      label: coach.institute_name,
                      id: coach.institute_id,
                    }))}
                    Height="auto"
                    OverFlow="auto"
                    minheight="300px"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
    </div>
  );
}

export default PersonalInfo;
